import { isSymbol } from "@shared/types/utils";
import { LeverageType } from "@shared/features/bots/BotForm/common/types";
import { MARGIN_TYPE_TO_DISPLAY } from "@shared/common/constants";
import { MarginData } from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/types";
import { translateOptionName } from "@shared/common/i18n/optionNames";
import i18n from "i18next";

export const getSymbolMarginPreview = ({
  multiplier,
  marginType,
  leverageType,
}: MarginData) => {
  if (isSymbol(multiplier) && isSymbol(marginType))
    return translateOptionName("Channel");
  let multiplierText = "";
  if (isSymbol(multiplier) || isSymbol(leverageType))
    multiplierText = translateOptionName("Channel");
  else if (multiplier)
    multiplierText =
      leverageType === LeverageType.UP_TO
        ? i18n.t("bots:margin.up_to", { value: multiplier })
        : `${multiplier}x`;
  let marginTypeText = "";
  if (isSymbol(marginType)) marginTypeText = translateOptionName("Channel");
  else if (marginType)
    marginTypeText = translateOptionName(MARGIN_TYPE_TO_DISPLAY[marginType]);
  return {
    marginType: marginTypeText,
    multiplier: multiplierText,
  };
};
